enum ErrorCode {
  SIGN_IN_ERROR = 'ERRSIGN001',
}

export { ErrorCode };
